import script from "./HomeProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeProfile.vue?vue&type=script&setup=true&lang=ts"

export default script